<script setup lang="ts"></script>

<template>
  <v-card elevation="0" flat>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
          <h2>
            Please
            <a
              target="_blank"
              href="https://learn.microsoft.com/office/dev/add-ins/testing/test-debug-office-add-ins#sideload-an-office-add-in-for-testing"
            >
              sideload
            </a>
            your add-in to see app body.
          </h2>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
